import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import type { ValueMap } from "../types";

const MAX_TOOLTIP_CHARACTERS = 90;

interface IUseCompetitorsDisplayTextParams {
    selectedCompetitors: ValueMap;
    isDefaultSelected: boolean;
}

export const useCompetitorsDisplayText = ({
    selectedCompetitors,
    isDefaultSelected,
}: IUseCompetitorsDisplayTextParams) => {
    const { translate } = useTranslate();

    const displayText = useMemo(() => {
        if (isDefaultSelected) {
            return translate("activation.alerts.competitors.dropdown.all.competitors-without-count");
        }

        return selectedCompetitors.size === 1
            ? Array.from(selectedCompetitors.values())[0].label
            : translate("activation.alerts.competitors.dropdown.some.competitors", {
                  selection: selectedCompetitors.size,
              });
    }, [selectedCompetitors, isDefaultSelected, translate]);

    const tooltipContent = useMemo(() => {
        const labels = Array.from(selectedCompetitors.values())
            .map((item) => item.label)
            .join(", ");

        if (labels.length <= MAX_TOOLTIP_CHARACTERS) {
            return labels;
        }

        return `${labels.slice(0, MAX_TOOLTIP_CHARACTERS)}...`;
    }, [selectedCompetitors]);

    const showTooltip = selectedCompetitors.size > 1;

    return {
        displayText,
        tooltipContent,
        showTooltip,
    };
};
